import React, { Fragment, useEffect } from 'react';
import Header6 from '../../components/header6/Header6';
import Hero6 from '../../components/hero6/hero6';
import PartnerSection from '../../components/Help-Desk-Components/PartnerSection';
import FeaturesService from '../../components/Help-Desk-Components/FeaturesService/FeaturesService';
import VideoService from '../../components/Help-Desk-Components/VideoService/VideoService';
import PricingSection from '../../components/Help-Desk-Components/PricingPage/Pricing';
import ContactSection from '../../components/ContactSection';
import CtaBanner from '../../components/Help-Desk-Components/CtaBanner/CtaBanner';
import Footer from '../../components/Help-Desk-Components/Footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const HomePage6 = () => {

    useEffect(() => {
        const urlHash = window.location.hash;
        if (urlHash.length) {
            const element = document.getElementById(urlHash.substring(1));
            if (element) {
                element.scrollIntoView();
            }
        }
    }, []);

    return (
        <Fragment>
            <div className='help_desk'>
                <main className="page_content">
                    <Header6 source={'home'} />
                    <Hero6 />
                    <PartnerSection />
                    <FeaturesService />
                    <VideoService />
                    <PricingSection />
                    <ContactSection />
                    <CtaBanner />
                    <Scrollbar />
                </main>
                <Footer />
            </div>
        </Fragment>
    )
};

export default HomePage6;
